"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _styledUtils = require("@sloth-system/styled-utils");

var _props = require("@sloth-system/props");

var _native = _interopRequireDefault(require("styled-components/native"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let BaseInput = (0, _native.default)(_TextInput.default)`
  ${_props.paddingProps}
  ${_props.borderRadiusProps}
  ${_props.backgroundColorProps}
  border: 2px solid ${(0, _styledUtils.color)("gray.lighter")};
  text-align: right;
  font-size: 16;
  font-family: "Vazir-Bold";
`;

function Input(props) {
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      position: "relative"
    }
  }, props.prefix && /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      position: "absolute",
      right: 10,
      top: 20
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, null, props.prefix)), /*#__PURE__*/_react.default.createElement(BaseInput, {
    bg: props.bg,
    p: props.p,
    pr: props.prefix && "xxxl",
    br: "xm",
    onChangeText: props.onChangeText,
    value: props.value,
    placeholder: props.placeholder,
    onSubmitEditing: props.onSubmit,
    keyboardType: props.keyboardType,
    disabled: props.disabled,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }), /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      position: "absolute",
      top: 8,
      left: 8
    }
  }, props.action)));
}

var _default = Input;
exports.default = _default;